import React, { useEffect, useState, useRef } from "react";
import CustomListingSelector from "../../shared/CustomListingSelector";
import CustomCheckBox from "../../shared/CustomCheckbox";
import PriceRangeGraph from "../../shared/PriceRangeGraph";
import { Filter } from "../../../svgs";
import { LuSearch } from "react-icons/lu";
import {
	cities,
	eventTypes,
	venueType,
	venueHire,
	Catering,
	venueSettings,
	Amenities,
	Menu,
	statesAndCities,
} from "../../../data";
import { RxCross1 } from "react-icons/rx";
import EventListingSelector from "../../shared/EventListingSelector";
import { IoMdArrowDropdown } from "react-icons/io";
import PricingFilter from "../PricingFilter";
import Modal from "../../shared/custom-modal/custom-modal";

function countValidKeyValuePairs(obj) {
	let count = 0;

	// Iterate through the keys of the object
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			const value = obj[key];

			// Check the conditions based on the value type
			if (Array.isArray(value)) {
				// Check if the array length is at least 1
				if (value.length >= 1) {
					count++;
				}
			} else if (typeof value === "string") {
				// Check if the string has at least 1 character
				if (value.length > 0) {
					count++;
				}
			} else if (typeof value === "number") {
				// Check if the number is greater than zero
				if (value > 0) {
					count++;
				}
			} else if (typeof value === "object" && value !== null) {
				if (
					["venueRental", "minSpendPerPerson", "minSpendPerEvent"].includes(key)
				) {
					const { min, max } = value || {};
					if ((min && Number(min) > 0) || (max && Number(max) > 0)) {
						count++;
					}
				} else if (Object.keys(value).length > 0) {
					count++;
				}
			}
		}
	}

	return count;
}

const popupKeyPair = {
	eventTypes: true,
	venueTypes: true,
	venueHire: true,
	catering: true,
	venueSettings: true,
	amenities: true,
	menus: true,
	area: true,
	guests: true,
	offersAvailable: true,
	pricing: true,
	// minSpendPerPerson: true,
	// minSpendPerEvent: true,
	numberOfRooms: true,
};
const VenueFilter = ({ filters, setFilters, page, setPage }) => {
	const [showFilter, setShowFilter] = useState(false);
	const [searchValue, setSearchValue] = useState();
	const [city, setCity] = useState(filters?.city || "");
	const [selectedEventTypes, setSelectedEventTypes] = useState([
		filters.eventTypes,
	]);
	const [selectedVenueTypes, setSelectedVenueTypes] = useState([
		filters.venueTypes,
	]);
	const [selectedVenueHire, setSelectedVenueHire] = useState([]);
	const [numberOfStandingGuests, setNumberOfStandingGuests] = useState(
		filters.standingGuests
	);
	const [numberOfSittingGuests, setNumberOfSittingGuests] = useState(
		filters.sittingGuests
	);

	const calledRef = useRef(false);

	const [guestType, setGuestType] = useState("standing"); // Tracks which button is pressed (standing or sitting)
	const [inputValue, setInputValue] = useState(filters.standingGuests); // General input value
	const [offersAvailable, setOffersAvailable] = useState(false);
	const [selectedCatering, setSelectedCatering] = useState([]);
	const [selectedVenueSetting, setSelectedVenueSetting] = useState([]);
	const [selectedAmenities, setSelectedAmenities] = useState([]);
	const [selectedMenus, setSelectedMenus] = useState([]);
	const [selectedArea, setSelectedArea] = useState([]);
	const [sittingGuests, setSittingGuests] = useState(filters.sittingGuests);
	const [standingGuests, setStandingGuests] = useState(filters.standingGuests);

	const [openPopup, setOpenPopup] = useState(popupKeyPair);

	const [minSpendPerPerson, setMinSpendPerPerson] = useState({
		min: 0,
		max: 6000,
	});

	const [minSpendPerEvent, setMinSpendPerEvent] = useState({
		min: 0,
		max: 6000,
	});
	const [showWarningModal, setShowWarningModal] = useState(false);

	const handlePricePerEventChange = (minValue, maxValue) => {
		setFilters((prevFilters) => ({
			...prevFilters,
			minSpendPerEvent: { max: maxValue, min: minValue },
		}));
	};
	const handleOpenPopup = (name) => {
		setOpenPopup((prev) => ({
			...prev,
			[name]: !prev[name],
		}));
	};
	const handlePricePerPersonChange = (minValue, maxValue) => {
		setFilters((prevFilters) => ({
			...prevFilters,
			minSpendPerPerson: { max: maxValue, min: minValue },
			setMinSpendPerPerson: {
				min: {
					min: minValue * filters.standingGuests,
					max: maxValue * filters.standingGuests,
				},
			},
		}));
	};

	useEffect(() => {
		if (filters.venueTypes?.length > 0) {
			handleVenueTypesChange(filters.venueTypes);
		}
	}, [calledRef.current]);

	setTimeout(() => {
		calledRef.current = true;
	}, 2000);

	useEffect(() => {
		countValidKeyValuePairs(filters);
	}, [filters]);

	useEffect(() => {
		setCity(filters.city || "");
	}, [filters.city]);

	const handleSearchChange = (e) => {
		setSearchValue(e.target.value);
		setFilters((prevFilters) => ({
			...prevFilters,
			search: e.target.value,
		}));
	};

	const handleCityChange = (e) => {
		setCity(e.target.value);
		setFilters((prevFilters) => ({
			...prevFilters,
			city: e.target.value,
			area: [],
		}));
	};

	const handleEventTypesChange = (selectedOptions) => {
		setSelectedEventTypes(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			eventTypes: selectedOptions,
		}));
	};

	const handleVenueTypesChange = (selectedOptions = [], value) => {
		const restaurantRelatedTypes = [
			"Bar",
			// "Beach club",
			"Cafes",
			"Dinner Show",
			"Fine dining restaurant",
			"Karaoke bar",
			"Nightclub",
			"Night Life",
			"Restaurant",
			"Restaurant/Bar",
			"Restaurant/Lounge & Bar",
			"Rooftops Restaurant",
			"Social clubs and lounges",
			"Supper club",
		];

		const corporateVenue = [
			"Conference center",
			// "Ballroom",
			"Co-working space",
			"Exhibitions Halls",
			// "Golf courses",
			"Meeting Center",
			"Meeting room",
			// "Team activity",
			"Training room",
		];

		let restaurantcheck = 0;
		let conferencecheck = 0;

		selectedOptions.forEach((option) => {
			if (restaurantRelatedTypes.includes(option)) restaurantcheck += 1;
			if (corporateVenue.includes(option)) conferencecheck += 1;
		});

		let isRestaurant =
			selectedOptions.some((item) => restaurantRelatedTypes.includes(item)) &&
			restaurantcheck === 1;

		let isConference =
			selectedOptions.some((item) => corporateVenue.includes(item)) &&
			conferencecheck === 1;
		if (isRestaurant)
			selectedOptions = [...selectedOptions, ...restaurantRelatedTypes];
		if (isConference) selectedOptions = [...selectedOptions, ...corporateVenue];
		selectedOptions = [...new Set([...selectedOptions])];
		setSelectedVenueTypes(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			venueTypes: selectedOptions,
		}));
	};

	const handleVenueHireChange = (selectedOptions) => {
		setSelectedVenueHire(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			venueHire: selectedOptions,
		}));
	};

	const handleButtonClick = (type) => {
		setGuestType(type);
		// if (type === "standing") {
		//   setInputValue(numberOfStandingGuests);
		// } else {
		//   setInputValue(numberOfSittingGuests);
		// }
	};

	const handleGuestNumberChange = () => {
		if (guestType === "standing") {
			setNumberOfStandingGuests(standingGuests);
			setSittingGuests("");
			setFilters((prevFilters) => ({
				...prevFilters,
				standingGuests: standingGuests,
				sittingGuests: "",
			}));
		} else {
			setNumberOfSittingGuests(sittingGuests);
			setStandingGuests("");
			setFilters((prevFilters) => ({
				...prevFilters,
				sittingGuests: sittingGuests,
				standingGuests: "",
			}));
		}
	};

	const handleCateringChange = (selectedOptions) => {
		setSelectedCatering(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			catering: selectedOptions,
		}));
	};

	const handleVenueSettingChange = (selectedOptions) => {
		setSelectedVenueSetting(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			venueSettings: selectedOptions,
		}));
	};

	const handleAmenitiesChange = (selectedOptions) => {
		setSelectedAmenities(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			amenities: selectedOptions,
		}));
	};
	const handleMenusChange = (selectedOptions) => {
		setSelectedMenus(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			menus: selectedOptions,
		}));
	};

	const handleAreaChange = (selectedOptions) => {
		setSelectedArea(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			area: selectedOptions,
		}));
	};

	const handleOffersChange = () => {
		setOffersAvailable(!offersAvailable);
		setFilters((prevFilters) => ({
			...prevFilters,
			offersAvailable: !offersAvailable,
		}));
	};

	const handleInputChange = (e) => {
		setInputValue(e.target.value);
	};

	const handleShowFilters = () => {
		setShowFilter(true);
		document.body.style.overflow = "hidden";
	};

	const handleCloseFilters = () => {
		setShowFilter(false);
		document.body.style.overflow = "auto";
	};

	const resetAll = () => {
		setCity("");
		setSelectedEventTypes([]);
		setSelectedVenueTypes([]);
		setSelectedVenueHire([]);
		setNumberOfStandingGuests("");
		setNumberOfSittingGuests("");
		setGuestType(null);
		setInputValue("");
		setSittingGuests("");
		setStandingGuests("");
		setOffersAvailable(false);
		setSelectedCatering([]);
		setSelectedVenueSetting([]);
		setSelectedAmenities([]);
		setSelectedMenus([]);
		setSelectedArea([]);
		setMinSpendPerPerson(null);
		setMinSpendPerEvent(null);
		setSearchValue("");
		setFilters({
			search: "",
			city: "",
			eventTypes: [],
			venueTypes: [],
			venueHire: [],
			standingGuests: "",
			sittingGuests: "",
			catering: [],
			venueSettings: [],
			amenities: [],
			menus: [],
			area: [],
			venueRental: { min: "", max: "" },
			minSpendPerPerson: { min: "", max: "" },
			minSpendPerEvent: { min: "", max: "" },
		});
		setPage(1);
	};

	return (
		<>
			<div className="w-full flex flex-col  border-grayNeutral">
				<div className="md:flex hidden items-center justify-between w-full py-4">
					<p
						className="text-[#FE4747] underline font-medium cursor-pointer hover:text-dark"
						onClick={resetAll}
					>
						Reset All
					</p>
				</div>

				{
					<div className="flex items-end justify-between sm:gap-5 md:mt-0 mt-4 gap-3">
						<div className="flex-1">
							<p className="mb-2">Search</p>
							<div className="border border-grayNeutral flex items-center gap-2 justify-between px-3 py-2 rounded-full">
								<input
									type="text"
									placeholder="Search"
									className="bg-transparent outline-none w-[90%]"
									name=""
									id=""
									value={filters.search}
									onChange={handleSearchChange}
								/>
								<LuSearch className="flex-shrink-0" />
							</div>
						</div>
						<div
							onClick={handleShowFilters}
							className="border md:hidden block h-full mb-1 rounded-md p-3"
						>
							<Filter />
						</div>
					</div>
				}

				<div className="mt-4 md:block hidden">
					<p className="text-dark mb-2">
						<span>Location (Cities)</span>
						{/*<span*/}
						{/*	className="underline text-[#FE4747] ms-2 cursor-pointer"*/}
						{/*	onClick={() => {*/}
						{/*		setCity("");*/}
						{/*		setFilters((prevFilters) => ({*/}
						{/*			...prevFilters,*/}
						{/*			city: null,*/}
						{/*		}));*/}
						{/*	}}*/}
						{/*>*/}
						{/*	Reset*/}
						{/*</span>*/}
					</p>
					{/* <div className="relative cursor-pointer">
						<select
							value={city}
							onChange={handleCityChange}
							className="w-full text-grayNeutral py-2 px-3 cursor-pointer appearance-none border outline-none border-bordered rounded-md"
						>
							<option value="" disabled>
								{filters.city || "Select City"}
							</option>
							{cities.map((city) => (
								<option key={city.value} value={city.value}>
									{city.label}
								</option>
							))}
						</select>
						<IoMdArrowDropdown className="absolute text-dark text-xl right-2 top-1/2 -translate-y-1/2" />
					</div> */}

					{/* <div
						className="flex items-center space-x-2 overflow-x-auto scrollbar-hide py-2"
						style={{
							WebkitOverflowScrolling: "touch",
							scrollbarWidth: "none",
							msOverflowStyle: "none",
						}}
					>
						{cities.map((c) => (
							<div
								key={c.value}
								onClick={() => handleCityChange({ target: { value: c.value } })}
								className={`whitespace-nowrap px-4 py-2 rounded-full border transition-all duration-200 cursor-pointer 
				${
					city === c.value
						? "bg-[#FE4747] text-white border-[#FE4747]"
						: "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
				}`}
							>
								{c.label}
							</div>
						))}
					</div> */}
					<div className="flex flex-wrap items-center gap-2 py-2">
						{cities.map((c) => (
							<div
								key={c.value}
								onClick={() => handleCityChange({ target: { value: c.value } })}
								className={`whitespace-nowrap px-4 py-2 rounded-full border transition-all duration-200 cursor-pointer 
				${
					city === c.value
						? "bg-[#FE4747] text-white border-[#FE4747]"
						: "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
				}`}
							>
								{c.label}
							</div>
						))}
					</div>
				</div>

				<div className="md:block hidden">
					<EventListingSelector
						label={
							<p>
								<span onClick={() => handleOpenPopup("eventTypes")}>
									Event Type{" "}
								</span>
								{/*<span*/}
								{/*	className="underline text-[#FE4747]"*/}
								{/*	onClick={() => {*/}
								{/*		setSelectedEventTypes([]);*/}
								{/*		setFilters((prevFilters) => ({*/}
								{/*			...prevFilters,*/}
								{/*			eventTypes: [],*/}
								{/*		}));*/}
								{/*	}}*/}
								{/*>*/}
								{/*	Reset*/}
								{/*</span>*/}
							</p>
						}
						handleOpenPopup={() => handleOpenPopup("eventTypes")}
						openPopup={openPopup.eventTypes}
						events={eventTypes}
						selectedOptions={filters.eventTypes || selectedEventTypes} // Pass selected options
						setSelectedOptions={handleEventTypesChange} // Pass setter function
					/>
					<CustomListingSelector
						label={
							<p>
								<span onClick={() => handleOpenPopup("venueTypes")}>
									Venue Type{" "}
								</span>
								{/*<span*/}
								{/*	className="underline text-[#FE4747]"*/}
								{/*	onClick={() => {*/}
								{/*		setSelectedVenueTypes([]);*/}
								{/*		setFilters((prevFilters) => ({*/}
								{/*			...prevFilters,*/}
								{/*			venueTypes: [],*/}
								{/*		}));*/}
								{/*	}}*/}
								{/*>*/}
								{/*	Reset*/}
								{/*</span>*/}
							</p>
						}
						handleOpenPopup={() => handleOpenPopup("venueTypes")}
						openPopup={openPopup.venueTypes}
						selectOptions={venueType}
						selectedOptions={filters.venueTypes || selectedVenueTypes} // Pass selected options
						setSelectedOptions={handleVenueTypesChange} // Pass setter function
					/>
					<CustomListingSelector
						label={
							<p>
								<span onClick={() => handleOpenPopup("guests")}>
									No. of Guests{" "}
								</span>{" "}
								{/*<span*/}
								{/*	className="underline text-[#FE4747]"*/}
								{/*	onClick={() => {*/}
								{/*		setNumberOfSittingGuests("");*/}
								{/*		setNumberOfStandingGuests("");*/}
								{/*		setSittingGuests("");*/}
								{/*		setStandingGuests("");*/}
								{/*		setInputValue("");*/}
								{/*		setGuestType(null);*/}
								{/*		setFilters((prevFilters) => ({*/}
								{/*			...prevFilters,*/}
								{/*			standingGuests: "",*/}
								{/*			sittingGuests: "",*/}
								{/*			guestType: null,*/}
								{/*		}));*/}
								{/*	}}*/}
								{/*>*/}
								{/*	Reset*/}
								{/*</span>*/}
							</p>
						}
						content={
							<div>
								{/* <input
                  type="number"
                  className="w-full py-2 px-3 outline-none border border-grayNeutral bg-transparent rounded-lg"
                  placeholder={`Enter number of ${guestType || "guests"}`}
                  value={inputValue}
                  onChange={handleInputChange}
                /> */}
								{guestType === "standing" ? (
									<input
										type="number"
										min={0}
										className="w-full py-2 px-3 outline-none border border-grayNeutral bg-transparent rounded-lg"
										placeholder={`Enter number of standing`}
										value={standingGuests}
										onChange={(e) => {
											const value = e.target.value;
											if (
												value === "" ||
												(!isNaN(value) && Number(value) >= 0)
											) {
												setStandingGuests(value);
											}
										}}
									/>
								) : (
									<input
										type="number"
										min={0}
										className="w-full py-2 px-3 outline-none border border-grayNeutral bg-transparent rounded-lg"
										placeholder={`Enter number of sitting`}
										value={sittingGuests}
										onChange={(e) => {
											const value = e.target.value;
											if (
												value === "" ||
												(!isNaN(value) && Number(value) >= 0)
											) {
												setSittingGuests(value);
											}
										}}
									/>
								)}

								<div className="flex items-center gap-3 w-full mt-3">
									<button
										className={`border ${
											guestType === "standing" ? "bg-black text-white" : ""
										} border-dark w-full py-2 px-3 rounded-md`}
										onClick={() => handleButtonClick("standing")}
									>
										Standing
									</button>
									<button
										className={`border ${
											guestType === "sitting" ? "bg-black text-white" : ""
										} border-dark w-full py-2 px-3 rounded-md`}
										onClick={() => handleButtonClick("sitting")}
									>
										Sitting
									</button>
								</div>

								{guestType && (
									<button
										className="mt-3 bg-[#FE4747] text-white py-2 px-4 rounded-md border w-full"
										onClick={handleGuestNumberChange}
									>
										Apply
									</button>
								)}

								{/* Display the saved values */}
								{numberOfStandingGuests && guestType === "sitting" && (
									<div className="mt-4">
										<p className="font-medium">
											Number of Standing Guests: {numberOfStandingGuests}
										</p>
									</div>
								)}
								{numberOfSittingGuests && guestType === "standing" && (
									<div className="mt-4">
										<p className="font-medium">
											Number of Sitting Guests: {numberOfSittingGuests}
										</p>
									</div>
								)}
							</div>
						}
						handleOpenPopup={() => handleOpenPopup("guests")}
						openPopup={openPopup.guests}
					/>

					<CustomListingSelector
						label={
							<p>
								<span onClick={() => handleOpenPopup("pricing")}>Pricing</span>{" "}
								{/*<span*/}
								{/*	className="underline text-[#FE4747]"*/}
								{/*	onClick={() => {*/}
								{/*		setFilters((prevFilters) => ({*/}
								{/*			...prevFilters,*/}
								{/*			venueRental: { min: "", max: "" },*/}
								{/*			minSpendPerPerson: { min: "", max: "" },*/}
								{/*			minSpendPerEvent: { min: "", max: "" },*/}
								{/*			venueRentalEnabled: null,*/}
								{/*			perPersonEnabled: null,*/}
								{/*			minSpendEnabled: null,*/}
								{/*		}));*/}
								{/*	}}*/}
								{/*>*/}
								{/*	Reset*/}
								{/*</span>*/}
							</p>
						}
						content={
							<PricingFilter
								openPopup={openPopup}
								handleOpenPopup={handleOpenPopup}
								filters={filters}
								setFilters={setFilters}
								setMinSpendPerPerson={setMinSpendPerPerson}
								setMinSpendPerEvent={setMinSpendPerEvent}
								setShowWarningModal={setShowWarningModal}
							/>
						}
						openPopup={openPopup.pricing}
						handleOpenPopup={() => handleOpenPopup("pricing")}
					/>

					{/* <CustomListingSelector
            label={
              <p>
                <span onClick={() => handleOpenPopup("minSpendPerPerson")}>
                  Total Budget Per Person (AED)
                </span>{" "}
                <span
                  className="underline text-[#FE4747]"
                  onClick={() => {
                    setMinSpendPerPerson({ min: null, max: null });
                    setFilters((prevFilters) => ({
                      ...prevFilters,
                      minSpendPerPerson: null,
                    }));
                  }}
                >
                  Reset
                </span>
              </p>
            }
            content={
              <PriceRangeGraph
                minSpendPerPerson={minSpendPerPerson}
                setMinSpendPerPerson={setMinSpendPerPerson}
                updateFilters={handlePricePerPersonChange}
              />
            }
            handleOpenPopup={() => handleOpenPopup("minSpendPerPerson")}
            openPopup={openPopup.minSpendPerPerson}
          />

          <CustomListingSelector
            label={
              <p>
                <span onClick={() => handleOpenPopup("minSpendPerEvent")}>
                  Total Budget Per Event (AED){" "}
                </span>{" "}
                <span
                  className="underline text-[#FE4747]"
                  onClick={() => {
                    setMinSpendPerEvent({ min: 0, max: 6000 });
                    setFilters((prevFilters) => ({
                      ...prevFilters,
                      minSpendPerEvent: null,
                    }));
                  }}
                >
                  Reset
                </span>
              </p>
            }
            content={
              <PriceRangeGraph
                minSpendPerPerson={minSpendPerEvent}
                setMinSpendPerPerson={setMinSpendPerEvent}
                updateFilters={handlePricePerEventChange}
              />
            }
            handleOpenPopup={() => handleOpenPopup("minSpendPerEvent")}
            openPopup={openPopup.minSpendPerEvent}
          /> */}

					<CustomListingSelector
						label={
							<p>
								<span onClick={() => handleOpenPopup("offersAvailable")}>
									Offers
								</span>{" "}
								{/*<span*/}
								{/*	className="underline text-[#FE4747]"*/}
								{/*	onClick={() => {*/}
								{/*		setOffersAvailable(false);*/}
								{/*		setFilters((prevFilters) => ({*/}
								{/*			...prevFilters,*/}
								{/*			offersAvailable: false,*/}
								{/*		}));*/}
								{/*	}}*/}
								{/*>*/}
								{/*	Reset*/}
								{/*</span>*/}
							</p>
						}
						content={
							<CustomCheckBox
								label={"Offers Available"}
								isChecked={offersAvailable}
								onChange={handleOffersChange}
							/>
						}
						handleOpenPopup={() => handleOpenPopup("offersAvailable")}
						openPopup={openPopup.offersAvailable}
					/>
					<CustomListingSelector
						label={
							<p>
								<span onClick={() => handleOpenPopup("area")}>Area</span>{" "}
								{/*<span*/}
								{/*	className="underline text-[#FE4747]"*/}
								{/*	onClick={() => {*/}
								{/*		setSelectedArea([]);*/}
								{/*		setFilters((prevFilters) => ({*/}
								{/*			...prevFilters,*/}
								{/*			area: [],*/}
								{/*		}));*/}
								{/*	}}*/}
								{/*>*/}
								{/*	Reset*/}
								{/*</span>*/}
							</p>
						}
						selectOptions={
							city
								? statesAndCities[city]
								: [{ name: "No city selected yet!", value: "" }]
						}
						selectedOptions={selectedArea} // Pass selected options
						setSelectedOptions={handleAreaChange}
						handleOpenPopup={() => handleOpenPopup("area")}
						openPopup={openPopup.area}
					/>

					<CustomListingSelector
						label={
							<p>
								<span onClick={() => handleOpenPopup("venueHire")}>
									Venue Hire
								</span>{" "}
								{/*<span*/}
								{/*	className="underline text-[#FE4747]"*/}
								{/*	onClick={() => {*/}
								{/*		setSelectedVenueHire([]);*/}
								{/*		setFilters((prevFilters) => ({*/}
								{/*			...prevFilters,*/}
								{/*			venueHire: [],*/}
								{/*		}));*/}
								{/*	}}*/}
								{/*>*/}
								{/*	Reset*/}
								{/*</span>*/}
							</p>
						}
						selectOptions={venueHire}
						selectedOptions={selectedVenueHire} // Pass selected options
						setSelectedOptions={handleVenueHireChange}
						handleOpenPopup={() => handleOpenPopup("venueHire")}
						openPopup={openPopup.venueHire}
					/>

					<CustomListingSelector
						label={
							<p>
								<span onClick={() => handleOpenPopup("catering")}>
									Catering & Drinks
								</span>{" "}
								{/*<span*/}
								{/*	className="underline text-[#FE4747]"*/}
								{/*	onClick={() => {*/}
								{/*		setSelectedCatering([]);*/}
								{/*		setFilters((prevFilters) => ({*/}
								{/*			...prevFilters,*/}
								{/*			catering: [],*/}
								{/*		}));*/}
								{/*	}}*/}
								{/*>*/}
								{/*	Reset*/}
								{/*</span>*/}
							</p>
						}
						selectOptions={Catering}
						selectedOptions={selectedCatering} // Pass selected options
						setSelectedOptions={handleCateringChange}
						handleOpenPopup={() => handleOpenPopup("catering")}
						openPopup={openPopup.catering}
					/>

					<CustomListingSelector
						label={
							<p>
								<span onClick={() => handleOpenPopup("venueSettings")}>
									Venue Settings
								</span>{" "}
								{/*<span*/}
								{/*	className="underline text-[#FE4747]"*/}
								{/*	onClick={() => {*/}
								{/*		setSelectedVenueSetting([]);*/}
								{/*		setFilters((prevFilters) => ({*/}
								{/*			...prevFilters,*/}
								{/*			venueSettings: [],*/}
								{/*		}));*/}
								{/*	}}*/}
								{/*>*/}
								{/*	Reset*/}
								{/*</span>*/}
							</p>
						}
						selectOptions={venueSettings}
						selectedOptions={selectedVenueSetting}
						setSelectedOptions={handleVenueSettingChange}
						handleOpenPopup={() => handleOpenPopup("venueSettings")}
						openPopup={openPopup.venueSettings}
					/>

					<CustomListingSelector
						label={
							<p>
								<span onClick={() => handleOpenPopup("amenities")}>
									Amenities
								</span>{" "}
								{/*<span*/}
								{/*	className="underline text-[#FE4747]"*/}
								{/*	onClick={() => {*/}
								{/*		setSelectedAmenities([]);*/}
								{/*		setFilters((prevFilters) => ({*/}
								{/*			...prevFilters,*/}
								{/*			amenities: [],*/}
								{/*		}));*/}
								{/*	}}*/}
								{/*>*/}
								{/*	Reset*/}
								{/*</span>*/}
							</p>
						}
						selectOptions={Amenities}
						selectedOptions={selectedAmenities} // Pass selected options
						setSelectedOptions={handleAmenitiesChange}
						handleOpenPopup={() => handleOpenPopup("amenities")}
						openPopup={openPopup.amenities}
					/>

					<CustomListingSelector
						label={
							<p>
								<span onClick={() => handleOpenPopup("menus")}>Menu</span>{" "}
								{/*<span*/}
								{/*	className="underline text-[#FE4747]"*/}
								{/*	onClick={() => {*/}
								{/*		setSelectedMenus([]);*/}
								{/*		setFilters((prevFilters) => ({*/}
								{/*			...prevFilters,*/}
								{/*			menus: [],*/}
								{/*		}));*/}
								{/*	}}*/}
								{/*>*/}
								{/*	Reset*/}
								{/*</span>*/}
							</p>
						}
						selectOptions={Menu}
						selectedOptions={selectedMenus} // Pass selected options
						setSelectedOptions={handleMenusChange}
						handleOpenPopup={() => handleOpenPopup("menus")}
						openPopup={openPopup.menus}
					/>
				</div>

				{/* filters in mobile view */}
				{showFilter && (
					<div className="fixed inset-0 bg-black bg-opacity-50 z-50">
						<div className="bg-white h-full w-full px-4 pt-6 overflow-y-auto">
							<div className="relative">
								<div className="flex items-center justify-between w-full py-4">
									<div className="" onClick={handleCloseFilters}>
										<RxCross1 className="text-xl" />
									</div>
								</div>

								<div className="flex-1">
									<p className="mb-2">Search</p>
									<div className="border border-grayNeutral flex items-center gap-2 justify-between px-3 py-2 rounded-full">
										<input
											type="text"
											placeholder="Search"
											value={filters.search || searchValue}
											onChange={handleSearchChange}
											className="bg-transparent outline-none w-[90%]"
											name=""
											id=""
										/>
										<LuSearch className="flex-shrink-0" />
									</div>
								</div>

								<div className="mt-4">
									<p>
										<span>Location (Cities)</span>
										{/*<span*/}
										{/*	className="underline text-[#FE4747] ms-2 cursor-pointer"*/}
										{/*	onClick={() => {*/}
										{/*		setCity("");*/}
										{/*		setFilters((prevFilters) => ({*/}
										{/*			...prevFilters,*/}
										{/*			city: null,*/}
										{/*		}));*/}
										{/*	}}*/}
										{/*>*/}
										{/*	Reset*/}
										{/*</span>*/}
									</p>
									<div className="relative cursor-pointer">
										<select
											value={city}
											onChange={handleCityChange}
											className="w-full text-grayNeutral py-2 px-3 cursor-pointer appearance-none border outline-none border-bordered rounded-md"
										>
											<option value="" disabled>
												{filters.city || "Select City"}
											</option>
											{cities.map((city) => (
												<option key={city.value} value={city.value}>
													{city.label}
												</option>
											))}
										</select>
										<IoMdArrowDropdown className="absolute text-dark text-xl right-2 top-1/2 -translate-y-1/2" />
									</div>
								</div>

								<div className="pb-4">
									<EventListingSelector
										label={
											<p>
												<span onClick={() => handleOpenPopup("eventTypes")}>
													Event Type
												</span>{" "}
												{/*<span*/}
												{/*	className="underline text-[#FE4747]"*/}
												{/*	onClick={() => {*/}
												{/*		setSelectedEventTypes([]);*/}
												{/*		setFilters((prevFilters) => ({*/}
												{/*			...prevFilters,*/}
												{/*			eventTypes: [],*/}
												{/*		}));*/}
												{/*	}}*/}
												{/*>*/}
												{/*	Reset*/}
												{/*</span>*/}
											</p>
										}
										events={eventTypes}
										selectedOptions={filters.eventTypes || selectedEventTypes} // Pass selected options
										setSelectedOptions={handleEventTypesChange}
										handleOpenPopup={() => handleOpenPopup("eventTypes")}
										openPopup={openPopup.eventTypes}
									/>
									<CustomListingSelector
										label={
											<p>
												<span onClick={() => handleOpenPopup("venueTypes")}>
													Venue Type
												</span>{" "}
												{/*<span*/}
												{/*	className="underline text-[#FE4747]"*/}
												{/*	onClick={() => {*/}
												{/*		setSelectedVenueTypes([]);*/}
												{/*		setFilters((prevFilters) => ({*/}
												{/*			...prevFilters,*/}
												{/*			venueTypes: [],*/}
												{/*		}));*/}
												{/*	}}*/}
												{/*>*/}
												{/*	Reset*/}
												{/*</span>*/}
											</p>
										}
										selectOptions={venueType}
										selectedOptions={filters.venueTypes || selectedVenueTypes} // Pass selected options
										setSelectedOptions={handleVenueTypesChange}
										handleOpenPopup={() => handleOpenPopup("venueTypes")}
										openPopup={openPopup.venueTypes}
									/>
									<CustomListingSelector
										label={
											<p>
												<span onClick={() => handleOpenPopup("guests")}>
													No. of Guests{" "}
												</span>{" "}
												{/*<span*/}
												{/*	className="underline text-[#FE4747]"*/}
												{/*	onClick={() => {*/}
												{/*		setNumberOfSittingGuests("");*/}
												{/*		setNumberOfStandingGuests("");*/}
												{/*		setSittingGuests("");*/}
												{/*		setStandingGuests("");*/}
												{/*		setInputValue("");*/}
												{/*		setGuestType(null);*/}
												{/*		setFilters((prevFilters) => ({*/}
												{/*			...prevFilters,*/}
												{/*			standingGuests: "",*/}
												{/*			sittingGuests: "",*/}
												{/*			guestType: null,*/}
												{/*		}));*/}
												{/*	}}*/}
												{/*>*/}
												{/*	Reset*/}
												{/*</span>*/}
											</p>
										}
										content={
											<div>
												{guestType === "standing" ? (
													<input
														type="number"
														min={0}
														className="w-full py-2 px-3 outline-none border border-grayNeutral bg-transparent rounded-lg"
														placeholder={`Enter number of standing`}
														value={standingGuests}
														onChange={(e) => {
															const value = e.target.value;
															if (
																value === "" ||
																(!isNaN(value) && Number(value) >= 0)
															) {
																setStandingGuests(value);
															}
														}}
													/>
												) : (
													<input
														type="number"
														min={0}
														className="w-full py-2 px-3 outline-none border border-grayNeutral bg-transparent rounded-lg"
														placeholder={`Enter number of sitting`}
														value={sittingGuests}
														onChange={(e) => {
															const value = e.target.value;
															if (
																value === "" ||
																(!isNaN(value) && Number(value) >= 0)
															) {
																setSittingGuests(value);
															}
														}}
													/>
												)}

												<div className="flex items-center gap-3 w-full mt-3">
													<button
														className={`border ${
															guestType === "standing"
																? "bg-black text-white"
																: ""
														} border-dark w-full py-2 px-3 rounded-md`}
														onClick={() => handleButtonClick("standing")}
													>
														Standing
													</button>
													<button
														className={`border ${
															guestType === "sitting"
																? "bg-black text-white"
																: ""
														} border-dark w-full py-2 px-3 rounded-md`}
														onClick={() => handleButtonClick("sitting")}
													>
														Sitting
													</button>
												</div>

												{guestType && (
													<button
														className="mt-3 bg-[#FE4747] text-white py-2 px-4 rounded-md border w-full"
														onClick={handleGuestNumberChange}
													>
														Apply
													</button>
												)}

												{/* Display the saved values */}
												{numberOfStandingGuests && guestType === "sitting" && (
													<div className="mt-4">
														<p className="font-medium">
															Number of Standing Guests:{" "}
															{numberOfStandingGuests}
														</p>
													</div>
												)}
												{numberOfSittingGuests && guestType === "standing" && (
													<div className="mt-4">
														<p className="font-medium">
															Number of Sitting Guests: {numberOfSittingGuests}
														</p>
													</div>
												)}
											</div>
										}
										handleOpenPopup={() => handleOpenPopup("guests")}
										openPopup={openPopup.guests}
									/>

									{/* <CustomListingSelector
										label={
											<p>
												<span
													onClick={() => handleOpenPopup("minSpendPerPerson")}
												>
													Total Budget Per Person (AED)
												</span>{" "}
												<span
													className="underline text-[#FE4747]"
													onClick={() => {
														setMinSpendPerPerson({ min: 0, max: 6000 });
														setFilters((prevFilters) => ({
															...prevFilters,
															minSpendPerPerson: { max: 6000, min: 0 },
														}));
													}}
												>
													Reset
												</span>
											</p>
										}
										content={
											<PriceRangeGraph
												minSpendPerPerson={minSpendPerPerson}
												setMinSpendPerPerson={setMinSpendPerPerson}
												updateFilters={handlePricePerPersonChange}
											/>
										}
										handleOpenPopup={() => handleOpenPopup("minSpendPerPerson")}
										openPopup={openPopup.minSpendPerPerson}
									/>

									<CustomListingSelector
										label={
											<p>
												<span
													onClick={() => handleOpenPopup("minSpendPerEvent")}
												>
													Total Budget Per Event (AED){" "}
												</span>
												<span
													className="underline text-[#FE4747]"
													onClick={() => {
														setMinSpendPerEvent({ min: 0, max: 6000 });
														setFilters((prevFilters) => ({
															...prevFilters,
															minSpendPerEvent: { max: 6000, min: 0 },
														}));
													}}
												>
													Reset
												</span>
											</p>
										}
										content={
											<PriceRangeGraph
												minSpendPerPerson={minSpendPerEvent}
												setMinSpendPerPerson={setMinSpendPerEvent}
												updateFilters={handlePricePerEventChange}
											/>
										}
										handleOpenPopup={() => handleOpenPopup("minSpendPerEvent")}
										openPopup={openPopup.minSpendPerEvent}
									/> */}

									<CustomListingSelector
										label={
											<p>
												<span
													onClick={() => handleOpenPopup("offersAvailable")}
												>
													Offers
												</span>{" "}
												{/*<span*/}
												{/*	className="underline text-[#FE4747]"*/}
												{/*	onClick={() => {*/}
												{/*		setOffersAvailable(false);*/}
												{/*		setFilters((prevFilters) => ({*/}
												{/*			...prevFilters,*/}
												{/*			offersAvailable: false,*/}
												{/*		}));*/}
												{/*	}}*/}
												{/*>*/}
												{/*	Reset*/}
												{/*</span>*/}
											</p>
										}
										content={
											<CustomCheckBox
												label={"Offers Available"}
												isChecked={offersAvailable}
												onChange={handleOffersChange}
											/>
										}
										handleOpenPopup={() => handleOpenPopup("offersAvailable")}
										openPopup={openPopup.offersAvailable}
									/>

									<CustomListingSelector
										label={
											<p>
												<span onClick={() => handleOpenPopup("area")}>
													Area{" "}
												</span>{" "}
												{/*<span*/}
												{/*	className="underline text-[#FE4747]"*/}
												{/*	onClick={() => {*/}
												{/*		setSelectedArea([]);*/}
												{/*		setFilters((prevFilters) => ({*/}
												{/*			...prevFilters,*/}
												{/*			area: [],*/}
												{/*		}));*/}
												{/*	}}*/}
												{/*>*/}
												{/*	Reset*/}
												{/*</span>*/}
											</p>
										}
										selectOptions={
											city
												? statesAndCities[city]
												: [{ name: "No city selected yet!", value: "" }]
										}
										selectedOptions={selectedArea} // Pass selected options
										setSelectedOptions={handleAreaChange}
										handleOpenPopup={() => handleOpenPopup("area")}
										openPopup={openPopup.area}
									/>

									<CustomListingSelector
										label={
											<p>
												<span onClick={() => handleOpenPopup("venueHire")}>
													Venue Hire{" "}
												</span>
												<span
													className="underline text-[#FE4747]"
													onClick={() => {
														setSelectedVenueHire("");
														setFilters((prevFilters) => ({
															...prevFilters,
															venueHire: "",
														}));
													}}
												>
													Reset
												</span>
											</p>
										}
										selectOptions={venueHire}
										selectedOptions={selectedVenueHire} // Pass selected options
										setSelectedOptions={handleVenueHireChange}
										handleOpenPopup={() => handleOpenPopup("venueHire")}
										openPopup={openPopup.venueHire}
									/>

									<CustomListingSelector
										label={
											<p>
												<span onClick={() => handleOpenPopup("catering")}>
													Catering & Drinks{" "}
												</span>
												<span
													className="underline text-[#FE4747]"
													onClick={() => {
														setSelectedCatering([]);
														setFilters((prevFilters) => ({
															...prevFilters,
															catering: [],
														}));
													}}
												>
													Reset
												</span>
											</p>
										}
										selectOptions={Catering}
										selectedOptions={selectedCatering} // Pass selected options
										setSelectedOptions={handleCateringChange}
										handleOpenPopup={() => handleOpenPopup("catering")}
										openPopup={openPopup.catering}
									/>

									<CustomListingSelector
										label={
											<p>
												<span onClick={() => handleOpenPopup("venueSettings")}>
													Venue Settings{" "}
												</span>
												<span
													className="underline text-[#FE4747]"
													onClick={() => {
														setSelectedVenueSetting([]);
														setFilters((prevFilters) => ({
															...prevFilters,
															setSelectedVenueTypes: [],
														}));
													}}
												>
													Reset
												</span>
											</p>
										}
										selectOptions={venueSettings}
										selectedOptions={selectedVenueSetting} // Pass selected options
										setSelectedOptions={handleVenueSettingChange}
										handleOpenPopup={() => handleOpenPopup("venueSettings")}
										openPopup={openPopup.venueSettings}
									/>

									<CustomListingSelector
										label={
											<p>
												<span onClick={() => handleOpenPopup("amenities")}>
													Amenities{" "}
												</span>
												<span
													className="underline text-[#FE4747]"
													onClick={() => {
														setSelectedAmenities([]);
														setFilters((prevFilters) => ({
															...prevFilters,
															amenities: [],
														}));
													}}
												>
													Reset
												</span>
											</p>
										}
										selectOptions={Amenities}
										selectedOptions={selectedAmenities} // Pass selected options
										setSelectedOptions={handleAmenitiesChange}
										handleOpenPopup={() => handleOpenPopup("amenities")}
										openPopup={openPopup.amenities}
									/>

									<CustomListingSelector
										label={
											<p>
												<span onClick={() => handleOpenPopup("menus")}>
													Menu{" "}
												</span>
												<span
													className="underline text-[#FE4747]"
													onClick={() => {
														setSelectedMenus([]);
														setFilters((prevFilters) => ({
															...prevFilters,
															menus: [],
														}));
													}}
												>
													Reset
												</span>
											</p>
										}
										selectOptions={Menu}
										selectedOptions={selectedMenus} // Pass selected options
										setSelectedOptions={handleMenusChange}
										handleOpenPopup={() => handleOpenPopup("menus")}
										openPopup={openPopup.menus}
									/>
								</div>

								<div className="flex sticky bottom-0 shadow-lg items-center gap-4 bg-white py-1.5 text-sm w-full">
									<button
										className="bg-white py-3 flex justify-center items-center underline w-full"
										onClick={() => {
											resetAll();
											handleCloseFilters();
										}}
									>
										Reset all
									</button>
									<button
										className="bg-primary py-3 rounded-md flex justify-center text-white items-center  w-full"
										onClick={() => {
											handleCloseFilters();
										}}
									>
										Save Changes
									</button>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
			<Modal isOpen={showWarningModal}>
				<div className="mx-4">
					<h2 className="text-xl font-semibold text-yellow-600 mb-4 flex items-center">
						⚠️ Warning
					</h2>
					<p className="text-gray-700 mb-6 font-semibold text-lg mt-2">
						Please enter the number of guests before Proceeding.
					</p>
					<div className="flex justify-end">
						<button
							onClick={() => setShowWarningModal(false)}
							className="bg-primary hover:bg-red-600 text-white font-medium px-4 py-2 rounded-xl"
						>
							Okay
						</button>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default VenueFilter;
